  <div>
    <ng-content></ng-content>
  </div>
